import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { applyLeadVisibilityUserId } from 'src/app/utils/lead-visibility.util';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';

@Component({
  selector: 'app-lead-report-details',
  templateUrl: './lead-report-details.component.html',
  styleUrls: ['./lead-report-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class LeadReportDetailsComponent {
  title = "Lead Generation Overview";
  slug: string = '';

  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50];
  isDataLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  displayedColumns: string[] = [];
  renderColumns: string[] = [];

  startDate: any = new Date(new Date().setHours(0, 0, 0, 0));
  endDate: any = new Date(new Date().setHours(23, 59, 59, 999));

  isOpen = false;

  filterLoading = false;

  selecteTodayFilter: any = "Today";

  selecteLeadStatusFilter: any = {}

  selectedLeadStatusFilter: any[] = ["New"]

  selectedLeadSource: any[] = ["Tina"]

  selectedLeadOwnership: any[] = [];

  ownerList: any[] = [];

  leadStatusSetting = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadWonerSetting = {
    singleSelection: false,
    idField: 'user_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadStatusList: any[] = [
    "New",
    "Active",
    "Pipeline /Budgetary",
    "Contacted",
    "Qualified",
    "Converted",
    "Closed - Lost",
    "Closed - Won",
    "Follow-up",
    "Not Interested",
    "Duplicate",
    "Disqualified",
    "Marketing Qualified Lead (MQL)",
    "Sales Qualified Lead (SQL)",
  ]

  leadSourceList: any[] = [
    "Channel Partner",
    "Conference",
    "Field Visit",
    "Google",
    "Instagram",
    "Lead Gen Tools",
    "Live Session",
    "Personal",
    "Referral",
    "LinkedIn",
    "Website",
    "WhatsApp",
    "Tina",
    "Intern",
    "Other"
  ]


  displayedLebel: any = {};
  allLeadFeilds: any = [];
  filterArray: any = [];
  isFixedColumn: boolean = true;
  importColumnsArray: any = [];

  expandedElement: any = null;
  isAdmin = false;



  todaysFilter: any[] = [];

  initialLoad = true;
  constructor(private route: ActivatedRoute,
    private api: LeadService,
    private localStorage: LocalStorageService,
    private userService: UsersService
  ) {
    // Initialize the dataSource with expansion handling
    this.dataSource = new MatTableDataSource();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return true; // Add your filtering logic here if needed
    };
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
    this.isFixedColumn = localStorage.getIsFixedCol();
  }

  private applyLeadListVisibility(param: Record<string, any>): void {
    applyLeadVisibilityUserId(
      param,
      this.localStorage.getUserId(),
      this.isAdmin,
      this.localStorage.getClientId()
    );
  }

  // Maps each report slug to the column that the report is about, so it can be
  // surfaced as the first column of the table.
  private readonly primaryColumnBySlug: { [slug: string]: string } = {
    'leads-by-status': 'status',
    'converted-leads': 'status',
    'leads-by-source': 'source',
    'leads-by-ownership': 'lead_owner',
  };

  private applyPrimaryColumnOrder(): void {
    const primaryColumn = this.primaryColumnBySlug[this.slug];
    if (!primaryColumn) {
      return;
    }
    const columns = [...this.renderColumns];
    const primaryIndex = columns.indexOf(primaryColumn);
    if (primaryIndex === -1) {
      return;
    }
    columns.splice(primaryIndex, 1);
    columns.unshift(primaryColumn);
    this.displayedColumns = columns;
    this.renderColumns = columns;
  }

  getLeadsFields() {
    console.log("isFixedColumn", this.isFixedColumn);
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.displayedColumns = [];
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
      

        if (this.isAdmin) {
          this.displayedColumns.push('lead_owner');
        }

        if (this.isFixedColumn) {
          this.displayedColumns.push('contact_name');
          this.displayedColumns.push('source');
          this.displayedColumns.push('created_at');
          this.displayedColumns.push('contact_email');
          this.displayedColumns.push('contact_number');
          this.displayedColumns.push('organisation');
        }

        // Add expand column for call-log-report at the beginning
        if (this.slug === 'call-log-report') {
          this.displayedColumns = ['expand', ...this.displayedColumns];
        }

        // Add dynamic fields
        data?.fields?.forEach((element: any) => {
          if (element.isVisibleTable == 'true') {
            this.displayedColumns.push(element.field_name);
          }
          this.displayedLebel[element.field_name] = element.label;
        });

        // fixed columns irrespective of fixed column
        this.displayedColumns.push('type');
        this.displayedColumns.push('status');

        this.renderColumns = this.displayedColumns;

        this.applyPrimaryColumnOrder();

        // Refresh the data after setting up columns
        this.loadReportData();
      },
      error: (e) => {
        this.initialLoad = false;
        console.error(e);
      },
    });
  }

  loadReportData() {
    switch (this.slug) {
      case 'todays-leads':
        this.getTodaysLeads();
        break;
      case 'leads-by-status':
        this.getLeadsByStatus();
        break;
      case 'leads-by-source':
        this.getLeadsBySource();
        break;
      case 'leads-by-ownership':
        this.getLeadsByOwnership();
        break;
      case 'leads-by-industry':
        this.getLeadsByIndustry();
        break;
      case 'converted-leads':
        this.getConvertedLeads();
        break;
      case 'call-log-report':
        this.getCallLogsReport();
        break;
      case 'email-log-report':
        this.getEmailLogsReport();
        break;
    }
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe(params => {
      this.slug = params.get('slug') || '';
      this.setTitle();
      this.getLeadsFields();
      if (this.slug === 'leads-by-ownership' || this.slug === 'call-log-report' || this.slug === 'email-log-report') {
        this.getAllLeadOwners();
      }
    });
  }

  getColumnLabel(col: string): string {
    // Map column names to display labels
    const columnLabels: { [key: string]: string } = {
      'lead_owner': 'Lead Owner',
      'source': 'Source',
      'created_at': 'Created At',
      'contact_name': 'Contact Name',
      'contact_email': 'Contact Email',
      'contact_number': 'Contact Number',
      'organisation': 'Organization',
      'type': 'Type',
      'status': 'Status',
      'Expand': 'Call Details'
    };
    return columnLabels[col] || this.formatColumnName(col);
  }

  formatColumnName(name: string): string {
    // Convert snake_case to Title Case
    return name.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  isSourceImage(source: string) {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string) {
    return resolveLeadSourceImg(source);
  }

  setTitle() {
    switch (this.slug) {
      case 'todays-leads':
        this.title = "Lead Generation Overview";
        break;
      case 'leads-by-status':
        this.title = "Leads by Status";
        this.getLeadsByStatus();
        break;
      case 'leads-by-source':
        this.title = "Leads by Source";
        this.getLeadsBySource();
        break;
      case 'leads-by-ownership':
        this.title = "Leads by Ownership";
        this.selectedLeadOwnership = [
          {
            user_id: this.localStorage.getUserId(),
            name: `${this.localStorage.getFirstName()} ${this.localStorage.getLastName()}`
          }
        ];

        this.getLeadsByOwnership();
        this.getAllLeadOwners();
        break;
      case 'leads-by-industry':
        this.title = "Leads by Industry";
        this.getLeadsByIndustry();
        break;
      case 'converted-leads':
        this.title = "Converted Leads";
        this.getConvertedLeads();
        break;
      case 'call-log-report':
        this.title = "Call Log Report";
        this.getCallLogsReport();
        this.getAllLeadOwners();
        break;
      case 'email-log-report':
        this.title = "Email Log Report";
        this.getEmailLogsReport();
        this.getAllLeadOwners();
        break;
      default:
        this.title = "Report Details";
    }


    const today = new Date();
    const day = 24 * 60 * 60 * 1000; // one day in milliseconds
    const startOfWeek = (date: Date) => {
      const d = new Date(date);
      const diff = d.getDate() - d.getDay(); // Sunday as start of week
      return new Date(d.setDate(diff));
    };
    const endOfWeek = (date: Date) => {
      const d = startOfWeek(date);
      return new Date(d.getTime() + 6 * day);
    };
    const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
    const endOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3 + 3, 0);
    const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);
    const endOfYear = (date: Date) => new Date(date.getFullYear(), 11, 31);

    const addDays = (date: Date, days: number) => new Date(date.getTime() + days * day);

    this.todaysFilter = [
      {
        label: "Today",
        value: "today",
        start_date: new Date(today.setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "Yesterday",
        value: "yesterday",
        start_date: new Date(addDays(new Date(), -1).setHours(0, 0, 0, 0)),
        end_date: new Date(addDays(new Date(), -1).setHours(23, 59, 59, 999))
      },
      {
        label: "Last 3 Days",
        value: "last_3_days",
        start_date: new Date(addDays(new Date(), -2).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "Last 7 Days",
        value: "last_7_days",
        start_date: new Date(addDays(new Date(), -6).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "Last 14 Days",
        value: "last_14_days",
        start_date: new Date(addDays(new Date(), -13).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "Last 21 Days",
        value: "last_21_days",
        start_date: new Date(addDays(new Date(), -20).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "Last 30 Days",
        value: "last_30_days",
        start_date: new Date(addDays(new Date(), -29).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date().setHours(23, 59, 59, 999))
      },
      {
        label: "This Week",
        value: "this_week",
        start_date: new Date(startOfWeek(new Date()).setHours(0, 0, 0, 0)),
        end_date: new Date(endOfWeek(new Date()).setHours(23, 59, 59, 999))
      },
      {
        label: "Last Week",
        value: "last_week",
        start_date: new Date(addDays(startOfWeek(new Date()), -7).setHours(0, 0, 0, 0)),
        end_date: new Date(addDays(endOfWeek(new Date()), -7).setHours(23, 59, 59, 999))
      },
      {
        label: "This Quarter",
        value: "this_quarter",
        start_date: new Date(startOfQuarter(new Date()).setHours(0, 0, 0, 0)),
        end_date: new Date(endOfQuarter(new Date()).setHours(23, 59, 59, 999))
      },
      {
        label: "Last Quarter",
        value: "last_quarter",
        start_date: new Date(addDays(startOfQuarter(new Date()), -90).setHours(0, 0, 0, 0)),
        end_date: new Date(addDays(startOfQuarter(new Date()), -1).setHours(23, 59, 59, 999))
      },
      {
        label: "This Month",
        value: "this_month",
        start_date: new Date(startOfMonth(new Date()).setHours(0, 0, 0, 0)),
        end_date: new Date(endOfMonth(new Date()).setHours(23, 59, 59, 999))
      },
      {
        label: "Last Month",
        value: "last_month",
        start_date: new Date(new Date(today.getFullYear(), today.getMonth() - 1, 1).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date(today.getFullYear(), today.getMonth(), 0).setHours(23, 59, 59, 999))
      },
      {
        label: "This Year",
        value: "this_year",
        start_date: new Date(startOfYear(new Date()).setHours(0, 0, 0, 0)),
        end_date: new Date(endOfYear(new Date()).setHours(23, 59, 59, 999))
      },
      {
        label: "Last Year",
        value: "last_year",
        start_date: new Date(new Date(today.getFullYear() - 1, 0, 1).setHours(0, 0, 0, 0)),
        end_date: new Date(new Date(today.getFullYear() - 1, 11, 31).setHours(23, 59, 59, 999))
      }
    ];


  }


  getTodaysLeads() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: { client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId() },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              startDate: this.startDate,
              endDate: this.endDate,
              order: {
                order: "updatedAt",
                dir: 'DESC',
              },
            };

            this.applyLeadListVisibility(param);

            return this.api
              .getAllData(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  getLeadsByStatus() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                lead_status: this.selectedLeadStatusFilter
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                order: "updatedAt",
                dir: 'DESC',
              },
            };

            this.applyLeadListVisibility(param);

            return this.api
              .getAllData(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  getLeadsBySource() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                lead_source: this.selectedLeadSource
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                order: "updatedAt",
                dir: 'DESC',
              },
            };

            this.applyLeadListVisibility(param);

            return this.api
              .getAllData(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  getAllLeadOwners() {
    try {

      let param = {
        client_id: this.localStorage.getClientId(),
      };

      this.userService.findAllUsers(param).subscribe({
        next: (data) => {
          this.ownerList = data;

          this.ownerList = this.ownerList.map((owner: any) => {
            return {
              user_id: owner.user_id,
              name: `${owner.fname} ${owner.lname}`,
            };
          });
        },
        error: (e) => {
          console.error(e);
        },
        complete: () => { },
      });
    } catch (e) {
      console.error(e);
    }
  }

  getLeadsByOwnership() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                user_id: this.selectedLeadOwnership?.map((owner: any) => owner.user_id)
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                order: "updatedAt",
                dir: 'DESC',
              },
            };

            this.applyLeadListVisibility(param);

            return this.api
              .getAllData(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  getLeadsByIndustry() {
  }

  getConvertedLeads() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                lead_status: "Converted"
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                order: "updatedAt",
                dir: 'DESC',
              },
            };

            this.applyLeadListVisibility(param);

            return this.api
              .getAllData(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  getCallLogsReport() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            const payload: any = {
              advanced_filters: {
                "owner_assigned": {
                  "checked": false,
                  "condition": "with"
                },
                "followup": {
                  "checked": false,
                  "condition": "with"
                },
                "notes": {
                  "checked": false,
                  "condition": "with"
                },
                "meeting": {
                  "checked": false,
                  "condition": "without"
                },
                "task": {
                  "checked": false,
                  "condition": "with"
                },
                "calls": {
                  "checked": true,
                  "condition": "with"
                },
                "emails": {
                  "checked": false,
                  "condition": "with"
                }
              },
              client_id: this.localStorage.getClientId(),
              center_id: this.localStorage.getCenterId(),
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              "where": {},
              startDate: this.startDate,
              endDate: this.endDate,
            }

            this.applyLeadListVisibility(payload);

            if (this.selectedLeadOwnership && this.selectedLeadOwnership.length > 0) {
              payload.user_id = this.selectedLeadOwnership.map((owner: any) => owner.user_id);
            }


            return this.api
              .getFilteredLeads(payload)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }



  getEmailLogsReport() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            const payload: any = {
              advanced_filters: {
                "owner_assigned": {
                  "checked": false,
                  "condition": "with"
                },
                "followup": {
                  "checked": false,
                  "condition": "with"
                },
                "notes": {
                  "checked": false,
                  "condition": "with"
                },
                "meeting": {
                  "checked": false,
                  "condition": "without"
                },
                "task": {
                  "checked": false,
                  "condition": "with"
                },
                "calls": {
                  "checked": false,
                  "condition": "with"
                },
                "emails": {
                  "checked": true,
                  "condition": "with"
                }
              },
              client_id: this.localStorage.getClientId(),
              center_id: this.localStorage.getCenterId(),
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              where: {},
              startDate: this.startDate,
              endDate: this.endDate,
            }

            this.applyLeadListVisibility(payload);

            if (this.selectedLeadOwnership && this.selectedLeadOwnership.length > 0) {
              payload.user_id = this.selectedLeadOwnership.map((owner: any) => owner.user_id);
            }

            return this.api
              .getFilteredLeads(payload)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  onTodaysFilterChange(event: any) {
    let selectedFilter = this.todaysFilter.find((filter) => filter.label === event);
    console.log(selectedFilter);
    this.startDate = selectedFilter.start_date;
    this.endDate = selectedFilter.end_date;
  }

  onFilterChange(event: any) {
    this.selecteLeadStatusFilter = event;
    this.onTodaysFilterChange(this.selecteTodayFilter);
  }


  openBulkFilter() {
    this.isOpen = true;
  }

  closeSidebar() {
    this.isOpen = false;
  }

  applyBulkFilter() {
    this.isOpen = false;
    if (this.slug == 'todays-leads') {
      this.getTodaysLeads();
    }
    if (this.slug == 'leads-by-status') {
      this.getLeadsByStatus();
    }
    if (this.slug == 'leads-by-source') {
      this.getLeadsBySource();
    }
    if (this.slug == 'leads-by-ownership') {
      this.getLeadsByOwnership();
    }
    if (this.slug == 'leads-by-industry') {
      this.getLeadsByIndustry();
    }
    if (this.slug == 'converted-leads') {
      this.getConvertedLeads();
    }
    if (this.slug == 'call-log-report') {
      this.getCallLogsReport();
    }
    if (this.slug == 'email-log-report') {
      this.getEmailLogsReport();
    }
  }
  clearFilter() {
    this.isOpen = false;
  }

  getOwnerName(owner: any) {
    if (owner && owner.fname && owner.lname) {
      return `${owner.fname} ${owner.lname}`;
    } else if (owner && owner.fname) {
      return owner.fname;
    } else if (owner && owner.lname) {
      return owner.lname;
    } else {
      return 'N/A';
    }
  }

  getTotalCalls(lead: any) {
    // let totalCalls = 0;
    // element.communication_logs?.filter(log => log.communication_type?.toLowerCase() ===
    //                             'call')?.length || 0

    return lead.communication_logs?.filter((log: any) => log.communication_type?.toLowerCase() ===
      'call')?.length || 0;
  }

}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
